export default __webpack_public_path__ + "static/media/essay.b5685b58.jpg";